import { ComponentType, ReactNode } from "react";
import { isBoxedValue, isHidden } from "../utils/is-hidden";
import { Hidden } from "gql/graphql";
import { Hidable } from "../model/types";
import { HiddenLabel } from "../views/hidden-label";
import { NotSpecified } from "../views/not-specified";
import { BoxedValueView } from "../views/boxed-value-view";

type ValueProps<T> = {
  data: Hidable<T>;
  view?: ComponentType<{ data: T }>;
  children?: (data: T) => ReactNode;
  whenHidden?: ComponentType<{ data: Hidden }>;
  whenEmpty?: ComponentType;
};

/**
 * Разводит три состояния защищённого поля: значение, «скрыто» и пустоту.
 *
 * Всё, кроме обёрнутых скаляров, требует view или children — сам по себе объект
 * компонент отрисовать не может и вернёт пустоту.
 */
export function Value<T>({
  data,
  view: View,
  children,
  whenHidden: WhenHidden = HiddenLabel,
  whenEmpty: WhenEmpty = NotSpecified,
}: ValueProps<T>) {
  if (data === null || data === undefined) {
    return <WhenEmpty />;
  }

  if (isHidden(data)) {
    return <WhenHidden data={data} />;
  }

  if (isBoxedValue(data) && !View && !children) {
    return <BoxedValueView data={data} />;
  }

  const value = data as T;

  if (children) {
    return <>{children(value)}</>;
  }

  return View ? <View data={value} /> : null;
}
